import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * `/live` and `/live/*` route handler.
 *
 * The actual files live at `/api/live/*` (the Kubernetes ingress only routes
 * `/api/*` to our backend). We just translate the browser URL on the fly:
 * visitors who hit `world-othello.com/live/foo.html` get bounced to
 * `world-othello.com/api/live/foo.html` where the operator's HTML/images/CSS
 * are served with the right content types.
 *
 * `replace` (not `assign`) keeps the browser history clean — nothing to
 * "back-navigate to" between `/live/x` and `/api/live/x`.
 */
export default function LiveRedirect() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    const rest = pathname.replace(/^\/live\/?/, "");
    const target = `/api/live/${rest}${search || ""}`;
    window.location.replace(target);
  }, [pathname, search]);

  return (
    <div className="min-h-[40vh] flex items-center justify-center text-sm text-muted-foreground">
      Opening live site…
    </div>
  );
}
